import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import { PAGES, PACKAGE_HOME_PATH } from 'checkout/store/constants';
import { getFullPath } from 'checkout/utils/globalUtils';

import SidebarMenuPayment from '../SidebarMenuPayment';

import type Props from './types';
import styles from './sidebarMenu.module.css';

const SidebarMenu = ({
  current,
  goToPath,
  completedStep,
  isManualPackage,
  isOrderFinished,
  isHotelOnly,
}: Props) => {
  const { t } = useTranslation();
  const menuItems = PAGES.map(({ path, menuText, manualFlightMenuText }) => ({
    path,
    text: isManualPackage ? manualFlightMenuText || menuText : menuText,
  })).filter(({ path }) => !isHotelOnly || path !== PACKAGE_HOME_PATH);

  return (
    <ul className={styles.list}>
      {menuItems
        .filter(({ text }, index) => text && index >= completedStep)
        .map(({ path, text }) => {
          const isCurrent = getFullPath(path) === current;
          return (
            <>
              <li
                className={cn(styles.item, { [styles.currentItem]: isCurrent })}
                key={path}
              >
                {isCurrent ? (
                  <span className={cn(styles.text, styles.currentText)}>
                    {text}
                  </span>
                ) : (
                  <button
                    className={cn(styles.text, styles.itemButton)}
                    type="button"
                    onClick={() => goToPath(path)}
                  >
                    {text}
                  </button>
                )}
              </li>
              {!isCurrent && <li className={cn(styles.separator)} />}
            </>
          );
        })}
      <li className={styles.item}>
        {isOrderFinished ? (
          <div className={styles.finishedOrderItem}>
            <p className={styles.text}>{t('checkout.sidebar.orderFinished')}</p>
            <div className="lt-icon-success lt-icon-success__small">
              <i className="lt-icon-success__check" />
            </div>
          </div>
        ) : (
          <SidebarMenuPayment className={styles.unfinishedOrderItem} />
        )}
      </li>
    </ul>
  );
};

export default SidebarMenu;
